import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const convertFromSeconds = (seconds) => {
    let hours = Math.floor(seconds / 3600000);
    let minutes = Math.floor((seconds - (hours * 3600000)) / 60000);
    let sec = Math.floor((seconds - (hours * 3600000) - (minutes * 60000)) / 1000);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
}

export const processTimeFromEvents = (type, seconds) => {
    return type === 'countup' ? ++seconds : --seconds;
}

export const getTimers = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('timer.getTimers'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table/'+tableId+'/timers');
        Store.dispatch(loadingActions.loadingEnd('timer.getTimers'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('timer.getTimers'));
        return e.response.data;
    }
};

export const createTimer = async (tableId, data) => {
    Store.dispatch(loadingActions.loadingStart('timer.createTimer'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/timers', {
            ...data
        });
        Store.dispatch(loadingActions.loadingEnd('timer.createTimer'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('timer.createTimer'));
        return e.response.data;
    }
};

export const editTimer = async (tableId, id, data) => {
    Store.dispatch(loadingActions.loadingStart('timer.editTimer'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + '/table/'+tableId+'/timers/'+id, {
            ...data
        });
        Store.dispatch(loadingActions.loadingEnd('timer.editTimer'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('timer.editTimer'));
        return e.response.data;
    }
};

export const deleteTimer = async (tableId, id) => {
    Store.dispatch(loadingActions.loadingStart('timer.deleteTimer'));
    try {
        let resp = await axios.delete(process.env.REACT_APP_HOST + '/table/'+tableId+'/timers/'+id);
        Store.dispatch(loadingActions.loadingEnd('timer.deleteTimer'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('timer.deleteTimer'));
        return e.response.data;
    }
};
